<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import type { TFeedbackQuestion, TFeedbackStore, TFeedbackQuestionOption } from '../types';
import Checkbox from '@/core/components/base/Checkbox.vue';
import { RECOMMEND_DATA } from '../constants';
import { MUTATION_TYPES } from '../store/storeTypes';
import { MODULE_NAME } from '../constants';
import { useFeedback } from '../composable/useFeedback';

type Props = {
  question: TFeedbackQuestion;
};
const { getResultByQuestion, collapseSection } = useFeedback();
const result = computed(() => {
  return getResultByQuestion(question.id);
});
const store = useStore<{ state: { feedback: TFeedbackStore } }>();
const { question } = defineProps<Props>();

const toggle = (_: boolean, item: any) => {
  const answer: any = result.value?.answer || [];
  const itemIndex = answer.findIndex((reason: TFeedbackQuestionOption) => reason.key === item.key);
  if (itemIndex === -1) {
    answer.push(item);
  } else {
    answer.splice(itemIndex, 1);
  }

  store.commit(`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_RESULT}`, {
    questionType: question.type,
    questionId: question.id,
    answer,
  });
  setTimeout(() => {
    collapseSection(item.key === 'OTHER');
  }, 10);
};

const isChecked = (item: TFeedbackQuestionOption) => {
  return !!result.value?.answer?.find((reason: TFeedbackQuestionOption) => reason.key === item.key);
};

const showAreaOther = computed(() => {
  return !!result.value?.answer?.find((reason: TFeedbackQuestionOption) => reason.key === RECOMMEND_DATA[4].key);
});

const onChangeText = (event: Event) => {
  store.commit(`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_RESULT}`, {
    questionId: question.id,
    questionType: question.type,
    answer: result.value?.answer?.map((item: TFeedbackQuestionOption) => ({
      ...item,
      value: item.key === RECOMMEND_DATA[4].key ? event.target?.value : '',
    })),
  });
};
</script>

<template>
  <div
    v-for="item in question.options"
    :key="item.id"
    :class="{ 'border-light-500': !isChecked(item) }"
    class="!mb-2 flex !h-9 w-full cursor-pointer items-center rounded-[3px] border border-solid border-light-500 last:!mb-0 hover:border-blue-300">
    <div class="!pl-2" @click="toggle(false, item)" />
    <Checkbox
      :checked="isChecked(item)"
      :class="`feedback-checkbox ${isChecked(item) ? 'active' : ''}`"
      :locked="false"
      :disabled="false"
      :size="17.5"
      @update:checked="toggle(false, item)" />
    <span class="flex flex-1 !p-2 !pl-2 text-sm text-light-mode-high-contrast" @click="toggle(false, item)">{{
      item.label
    }}</span>
  </div>
  <textarea
    v-if="showAreaOther"
    placeholder="Type something..."
    class="h-[82px] rounded-[3px] border border-solid border-light-500 !p-2"
    @input="onChangeText" />
</template>

<style scoped lang="scss">
.feedback-checkbox {
  background-color: transparent !important;
  border: 1px solid #676767 !important;
  &.active {
    background-color: #3c67ff !important;
  }
}
</style>
